import type { MetaFunction } from '@remix-run/node'
import { Outlet, useLoaderData } from '@remix-run/react'

import ContainerWithContentFilters from '~/modules/layout/components/ContainerWithContentFilters'
import { printableFilterLoader } from '~/modules/printables/services/filter-data.server'
import { getLoaderCacheHeaders } from '~/utils/headers.server'

export const headers = getLoaderCacheHeaders

// 'handle' is data attached to a route match that can be accessed from any
// child route.
//
// In this case, we're using it to flag/identify loader data that is specific to
// this route, from the child
export const handle = {
  isPrintableRoute: true
}

export const meta: MetaFunction = () => [
  {
    title: 'Videos | Pevan & Sarah'
  },
  {
    name: 'description',
    content: 'Unique and engaging tools for teachers and parents to connect with all learners'
  }
]

export const loader = printableFilterLoader

const PrintablesWrapper = () => {
  const data = useLoaderData<typeof loader>()

  return (
    <ContainerWithContentFilters type="printable" learningAreas={data}>
      {/* This is the outlet for the nested route content */}
      <Outlet />
    </ContainerWithContentFilters>
  )
}

export default PrintablesWrapper
